import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip, Legend } from 'recharts';
import { UserCircle } from 'lucide-react';
import { getAgeDistribution } from '../../../services/dashboardService';
import { Card, CardHeader, CardTitle, EmptyState, ChartWrapper } from '../styles';

const COLORS = ['#0291EF', '#02D3BF', '#7C3AED', '#F97316', '#FF6B6B', '#FFC107'];

const renderLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent }) => {
  if (percent < 0.05) return null;
  const RADIAN = Math.PI / 180;
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);
  return (
    <text x={x} y={y} fill="#fff" textAnchor="middle" dominantBaseline="central" fontSize={11} fontWeight={700}>
      {`${(percent * 100).toFixed(0)}%`}
    </text>
  );
};

export default function AgeDistributionCard() {
  const { t } = useTranslation();
  const [data, setData] = useState([]);

  useEffect(() => {
    getAgeDistribution().then(res => {
      const d = res.data?.data;
      setData(Array.isArray(d) ? d.filter(item => item.value > 0) : []);
    });
  }, []);

  const chartData = data.map(d => ({ name: d.label, value: d.value }));

  return (
    <Card $delay="0.4s">
      <CardHeader>
        <CardTitle>{t('dashboard.ageDistribution')}</CardTitle>
      </CardHeader>
      {chartData.length === 0 ? (
        <EmptyState>
          <UserCircle size={32} />
          {t('dashboard.noData')}
        </EmptyState>
      ) : (
        <ChartWrapper>
          <ResponsiveContainer width="100%" height={240}>
            <PieChart>
              <Pie
                data={chartData}
                cx="50%"
                cy="50%"
                innerRadius={45}
                outerRadius={80}
                dataKey="value"
                labelLine={false}
                label={renderLabel}
                strokeWidth={2}
                stroke="#fff"
              >
                {chartData.map((_, i) => (
                  <Cell key={i} fill={COLORS[i % COLORS.length]} />
                ))}
              </Pie>
              <Tooltip contentStyle={{ borderRadius: 6, border: 'none', boxShadow: '0 4px 12px rgba(0,0,0,0.1)', fontSize: 13 }} />
              <Legend iconType="circle" iconSize={8} wrapperStyle={{ fontSize: 11 }} />
            </PieChart>
          </ResponsiveContainer>
        </ChartWrapper>
      )}
    </Card>
  );
}
